import api from '@/api';

export default {
  track: (recaptcha, codigoRastreio) => api.get(`track/${codigoRastreio}`, {
    params: {
      recaptcha,
    },
  }),
};
